import(/* webpackMode: "eager" */ "/workspace/src/app/my-collection/page.tsx");
